import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Edit as EditInterface } from "../../../../interfaces/reservation.interface";
import { Modules, RouteParamsTypes } from "../../../../enums";

interface FormHeaderProps {
  formData: EditInterface;
  view: boolean;
  external?: boolean;
}

const FormHeader: React.FC<FormHeaderProps> = ({ formData, view, external }) => {
  const { t } = useTranslation();

  const handleInvoiceClick = (id: string) => {
    window.open(`${Modules.invoices}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  const handleStatementClick = (id: number) => {
    window.open(`${Modules.reconciliation}${RouteParamsTypes.managerStatement}/${id}`, '_blank');
  }

  const segments: React.ReactNode[] = [
    t("reservations.edit.pageTexts.title.invoiceStatus", { status: formData.statusName || '-' }),
  ];

  if (formData.invoiceNo) {
    segments.push(
      <span className={clsx(!external && 'cursor-pointer text-decoration-underline hyperlink')} onClick={() => !external && handleInvoiceClick(formData.invoiceId)}>
        {t("reservations.edit.pageTexts.title.invoiceNo", { invoiceNumber: formData.invoiceNo })}
      </span>
    );
  }

  segments.push(
    t("reservations.edit.pageTexts.title.statementStatus", { status: formData.statementStatusName || '-' })
  );

  if (formData.managerStatement) {
    segments.push(
      <span className={clsx(!external && 'cursor-pointer text-decoration-underline hyperlink')} onClick={() => !external && handleStatementClick(formData.managerStatement!.id)}>
        {t("reservations.edit.pageTexts.title.statementNumber", { statementNumber: formData.managerStatement.statementNumber })}
      </span>
    );
  }

  return (
    <div className="d-flex justify-content-between">
      <h5 className={clsx("card-header", external && 'fs-4')}>{view ? t("reservations.edit.pageTexts.title.viewTitle") : t("reservations.edit.pageTexts.title.editTitle")}</h5>

      <div className={clsx("d-flex align-items-center flex-wrap text-primary fw-bold", !external && "p-5", external && "fs-6")}>
        {segments.map((segment, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="mx-2">|</span>}
            {segment}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default FormHeader;